import { FC } from 'react'
import { MdDelete } from 'react-icons/md'
import useIconInfo from '../../../hooks/useIconInfo'

type Props = {
  id: number
  name: string
  removeAPIMethod?: any
}

const DeleteButton: FC<Props> = (props) => {
  const { name, id, removeAPIMethod } = props
  const { iconSize } = useIconInfo()

  return (
    <div>
      <span
        id="delete"
        className="cursor-pointer"
        onClick={(e) => {
          const isOK = window.confirm(`${name}を削除してもよろしいでしょうか`)

          if (isOK) {
            removeAPIMethod(e, id)
          }
        }}
      >
        <MdDelete size={iconSize} title="削除" />
      </span>
    </div>
  )
}

export default DeleteButton
